import { Network, Cable, Camera, Sparkles, Server, Wrench, Printer, HardDrive, Cloud, Thermometer, Code, LifeBuoy, ArrowUpRight } from "lucide-react";

const services = [
  {
    icon: Network,
    title: "Network Solutions",
    desc: "From commercial offices to industrial environments, ZID IT Solutions delivers reliable IT services that keep your business connected, secure, and productive across Toronto.",
    image: "https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/8gd2k7h1_Network%20Solution%20image.png",
    span: "lg:col-span-4",
  },
  {
    icon: Cable,
    title: "Structured Cabling",
    desc: "Unlock seamless connectivity with professional structured cabling infrastructure solutions tailored to your business needs.",
    image: "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a",
    span: "lg:col-span-4",
  },
  {
    icon: Camera,
    title: "Security Cameras",
    desc: "Enhance your security with professional camera installation solutions that help protect your business, property, and assets.",
    image: "https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/fdphui07_Secuirty%20Camera.png",
    span: "lg:col-span-4",
  },
  {
    icon: Sparkles,
    title: "Cable Management",
    desc: "Say goodbye to cable clutter with professional cable management solutions that keep your workspace organized, efficient, and easy to maintain across Toronto.",
    image: "https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/h59iwild_Cable%20managment.png",
    span: "lg:col-span-4",
  },
  {
    icon: Server,
    title: "Rack and Stack",
    desc: "Enhance your IT infrastructure with professional rack installation, equipment setup, and cable organization solutions that keep your business network clean, reliable, and efficient across Toronto.",
    image: "https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/rg7vwlwg_Rack%20and%20Stack.png",
    span: "lg:col-span-4",
  },
  {
    icon: Wrench,
    title: "IT Services",
    desc: "From small businesses to industrial environments, we provide reliable IT solutions that keep your systems secure, connected, and running efficiently across Toronto.",
    image: "https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/dgidhxmp_IT%20Service.png",
    span: "lg:col-span-4",
  },
  {
    icon: Printer,
    title: "Printers",
    desc: "From printers sales and installation to troubleshooting, maintenance, and network connectivity, ZID IT Solutions provides reliable printing solutions to keep your home or business productive. We help with printers setup, driver installation, wireless issues, and ongoing support to keep your printing environment running smoothly.",
    image: "https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/1s0j7yrj_Printer.png",
    span: "lg:col-span-4",
  },
  {
    icon: HardDrive,
    title: "Data Backup & Drive Cloning",
    desc: "Protect your data with a bootable backup of your hard drive or SSD, including your operating system, applications, and files. If your original drive fails, simply connect the cloned drive and get back to work with minimal downtime. Ideal for legacy applications and critical business systems.",
    image: "https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/nvo7qr11_Back%20up.png",
    span: "lg:col-span-4",
  },
  {
    icon: Cloud,
    title: "Microsoft 365 & Google Workspace",
    desc: "Set up and manage your business cloud services with ease. ZID IT Solutions provides Microsoft 365 and Google Workspace setup, email migration, user management, security configuration, and troubleshooting to keep your team connected and productive.",
    image: "https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/yaiyr7ju_Migration.png",
    span: "lg:col-span-4",
  },
  {
    icon: Thermometer,
    title: "Smart Thermostat Installation",
    desc: "Our licensed technicians are experienced in working with HVAC systems and can safely install, configure, and optimize your smart thermostat. We provide reliable service to help improve comfort, energy efficiency, and smart home control.",
    image: "https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/v7u0nlr5_Smart%20Thermostate.png",
    span: "lg:col-span-4",
  },
  {
    icon: Code,
    title: "Website Design & Development",
    desc: "We create modern, responsive websites tailored to your business needs. Whether you need a professional business website, portfolio, landing page, or e-commerce store, we deliver fast, secure, and user-friendly solutions that help your business grow online.",
    image: "https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/7i0242ko_Website%20development.png",
    span: "lg:col-span-4",
  },
  {
    icon: LifeBuoy,
    title: "Application Support",
    desc: "We provide reliable support for legacy and business applications. From troubleshooting application errors to implementing secure backup solutions, we help keep your systems running smoothly with minimal downtime.",
    image: "https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/nly31ht0_Application%20Support.png",
    span: "lg:col-span-4",
  },
];

export const Services = () => {
  return (
    <section id="services" className="py-24 sm:py-32 bg-slate-50 border-y border-slate-200">
      <div className="container mx-auto px-6 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-widest text-blue-600">What We Do</span>
          <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter text-slate-950 mt-4">
            Your Trusted IT Partner
          </h2>
          <p className="text-lg text-slate-600 mt-5">
            From network cabling to complete IT support and security solutions, we keep your business connected, secure, and running smoothly across Toronto and the GTA.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mt-14">
          {services.map((s, i) => {
            const Icon = s.icon;

            if (s.wide) {
              return (
                <div
                  key={i}
                  data-testid={`service-card-${i}`}
                  className={`${s.span} group border border-slate-200 bg-white p-8 sm:p-10 hover:-translate-y-1 transition-transform duration-300 flex flex-col sm:flex-row sm:items-center gap-6`}
                >
                  <div className="h-14 w-14 flex-shrink-0 flex items-center justify-center bg-amber-400">
                    <Icon size={26} className="text-slate-950" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-heading text-2xl font-bold tracking-tight text-slate-950">{s.title}</h3>
                    <p className="mt-2 text-slate-600">{s.desc}</p>
                  </div>
                  <a href="#contact" data-testid={`service-cta-${i}`} className="inline-flex items-center gap-2 text-blue-600 font-semibold hover:gap-3 transition-all">
                    Learn more <ArrowUpRight size={18} />
                  </a>
                </div>
              );
            }

            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className={`${s.span} group border border-slate-200 bg-white p-8 sm:p-10 hover:-translate-y-1 transition-transform duration-300 flex flex-col ${
                  s.dark ? "bg-slate-950 text-white border-slate-950" : ""
                }`}
              >
                <div className="flex items-start justify-between">
                  <div className="h-14 w-14 flex items-center justify-center bg-blue-600">
                    <Icon size={26} className="text-white" />
                  </div>
                  <ArrowUpRight size={22} className={`${s.dark ? "text-slate-500" : "text-slate-300"} group-hover:text-blue-600 transition-colors`} />
                </div>
                <h3 className={`font-heading text-2xl font-bold tracking-tight mt-6 ${s.dark ? "text-white" : "text-slate-950"}`}>
                  {s.title}
                </h3>
                <p className={`mt-3 ${s.dark ? "text-slate-300" : "text-slate-600"} leading-relaxed`}>{s.desc}</p>
                {s.image && (
                  <div className="mt-auto pt-6 border-slate-200 overflow-hidden">
                    <div className="border border-slate-200 overflow-hidden">
                      <img src={s.image} alt={s.title} className="w-full h-40 object-cover group-hover:scale-105 transition-transform duration-500" />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
